const initialState = {
    isLoading: false,
    resourceContentLoaded: false,
    resourceContent: {},
};

function app(state = initialState, action) {
    switch (action.type) {
        case 'RESOURCE_CONTENT:FETCH_CONTENT_REQUEST':
            return {
                ...state,
                isLoading: true,
                resourceContentLoaded: false,
            };
        case 'RESOURCE_CONTENT:FETCH_CONTENT_SUCCESS':
            return {
                ...state,
                resourceContent: action.data,
                isLoading: false,
                resourceContentLoaded: true,
            };
        case 'RESOURCE_CONTENT:FETCH_CONTENT_FAILURE':
            return {
                ...state,
                isLoading: false,
                resourceContentLoaded: false,
            };
        default:
            return state;
    }
}

export default app;
